module.exports = __webpack_public_path__ + "static/img/Callum_Mills_mobile.02377e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Callum_Mills_mobile.jpg
// module id = B0xI
// module chunks = 0